import { Grid } from "@mui/material"
import { ReactElement } from "react"

const IconTitleCard = ({ title, icon }: { title: string, icon: ReactElement }) => {
    return (
        <Grid container sx={{
            borderRadius: '8px',
            border: '1px solid var(--border-color)', background: 'var(--input-bg-color)', padding: "20px", marginY: "10px", alignItems: "center"
        }}>
            <Grid item sx={{ color: "var(--tirnary-text-color)", marginLeft: "0.8rem", position: "relative" }}>{icon}</Grid>
            <Grid item sx={{ color: "var(--primary-text-color)", fontWeight: "bold", fontSize: "0.85rem" }}>{title}</Grid>
        </Grid>
    )
}

export default IconTitleCard